import React, { useEffect } from 'react'
import { Mail, Phone, User } from 'react-feather'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../../redux/store'
import { ToastType, useToast } from '../../components/ToastProvider'
import { useT } from '../../i18n'
import { testNumber } from '../../utils'
import { addListing, updateListing } from '../../redux/actions'
import FormInput from '../../components/utils/FormInput'
import style from '../../styles/pages/listing.module.scss'
import assets from '../../assets'
import Camera from '../../components/svgs/Camera'
import Edit from '../../components/svgs/Edit'
import { api } from '../../api'
import { ContentState, EditorState, convertToRaw } from 'draft-js'
import draftToHtml from "draftjs-to-html"
import { Editor } from 'react-draft-wysiwyg'
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"
import { Listing } from '../../redux/reducers/listing.reducer'
import { useSelector } from 'react-redux'
import { StoreState } from '../../redux/reducers'
import ModalWithHeader from '../modals/ModalWithHeader'
import htmlToDraft from "html-to-draftjs"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"

interface ListingFormProps {
    onClose?: () => void
    id?: string | null
}

const ListingForm = (props: ListingFormProps) => {
    const dispatch = useDispatch<AppDispatch>()
    const toast = useToast()
    const t = useT()
    const [name, setName] = React.useState<string>('')
    const [nameError, setNameError] = React.useState<string>('')
    const [title, setTitle] = React.useState<string>('')
    const [titleError, setTitleError] = React.useState<string>('')
    const [phoneNumber, setPhoneNumber] = React.useState<string>('')
    const [phoneNumberError, setPhoneNumberError] = React.useState<string>('')
    const [email, setEmail] = React.useState<string>('')
    const [emailError, setEmailError] = React.useState<string>('')
    const [message, setMessage] = React.useState<EditorState>(EditorState.createEmpty())
    const [messageError, setMessageError] = React.useState<string>('')
    const [image, setImage] = React.useState<any>('')
    const [imageError, setImageError] = React.useState<string>('')
    const [status, setStatus] = React.useState<any>('New')
    const [statusError, setStatusError] = React.useState<string>('')
    const [loading, setLoading] = React.useState<boolean>(false)
    const [onCamera, setOnCamera] = React.useState<boolean>(false)
    const Listing = useSelector<StoreState, Listing | null>(state => props.id ? state.listing.find(s => s.id === props.id) || null : null)

    const resetStates = () => {
        setName('')
        setNameError('')
        setImage('')
        setImageError('')
        setPhoneNumber('')
        setPhoneNumberError('')
        setEmail('')
        setEmailError('')
        setMessage(EditorState.createEmpty())
        setMessageError('')
        setTitle('')
        setTitleError('')
    }

    const NameChangeHandler: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        setName(e.target.value)
        setNameError('')
    }

    const TitleChangeHandler: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        setTitle(e.target.value)
        setTitleError('')
    }

    const PhonenumberChangeHandler: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        setPhoneNumber(e.target.value)
        setPhoneNumberError('')
    }

    const EmailChangeHandler: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        setEmail(e.target.value)
        setEmailError('')
    }

    const MessageChangeHandler = (editorState: EditorState) => {
        setMessage(editorState);
        setMessageError('')
    }

    const imageChangeHandler: React.ChangeEventHandler<HTMLInputElement | HTMLFormElement> = async (e) => {
        let response: any
        if (onCamera) {
            const formData: any = new FormData()
            formData.append("file", e.target.files[0]);
            response = await api.post<Response>(`upload-img/food`, formData);
        }
        onCamera ? setImage(response.data.data) : setImage(e.target.value)
        setImageError('')
    }

    const submitHandler: React.MouseEventHandler<HTMLButtonElement> = (e) => {

        e.preventDefault()

        let error = false

        const messageState = draftToHtml(convertToRaw(message.getCurrentContent()));
        const msg = messageState;

        if (name === '') {
            setNameError(t('Name required'))
            error = true
        }
        if (title === '') {
            setTitleError(t('Title required'))
            error = true
        }
        if (image === '') {
            setImageError(t('Image required'))
            error = true
        }
        if (phoneNumber === '') {
            setPhoneNumberError(t('Phone Number required'))
            error = true
        } else if ((phoneNumber).length > 15) {
            setPhoneNumberError(t('Phone Number should be within 15 digits'))
            error = true
        } else if (!testNumber(phoneNumber)) {
            setPhoneNumberError(t('Phone Number must be a number'))
            error = true
        }
        if (email === '') {
            setEmailError(t('Email required'))
            error = true
        }
        if (msg.toString() === '') {
            setMessageError(t('Message required'))
            error = true
        }
        if (phoneNumber === '') {
            setPhoneNumberError(t('Phone Number required'))
            error = true
        }

        if (props.id && Listing) {
            setLoading(true);
            dispatch(updateListing({
                title: title,
                name: name,
                image: image,
                phoneNumber: phoneNumber,
                email: email,
                message: msg,
            }, props.id))
                .then(() => {
                    resetStates();
                    toast(('Listing Details Updated'));
                    props.onClose?.()
                })
                .catch((text) => {
                    toast(text, ToastType.ERROR);
                })
                .finally(() => {
                    setLoading(false);
                });
        } else {
            setLoading(true);
            dispatch(addListing({
                title: title,
                name: name,
                image: image,
                phoneNumber: phoneNumber,
                email: email,
                message: msg,
                status: status
            }))
                .then(() => {
                    resetStates();
                    toast(t('Listing Details Submitted'));
                    props.onClose?.()
                })
                .catch((text) => {
                    toast(text, ToastType.ERROR);
                })
                .finally(() => {
                    setLoading(false);
                });
        }

    }

    useEffect(() => {
        if (Listing && props.id !== '') {
            setName(Listing.name)
            setTitle(Listing.title)
            setPhoneNumber(Listing.phoneNumber)
            setImage(Listing.image)
            setEmail(Listing.email)
            const contentEngBlock = htmlToDraft(Listing.message);
            const contentState = ContentState.createFromBlockArray(
                contentEngBlock.contentBlocks
            );
            const editorState = EditorState.createWithContent(contentState);
            setMessage(editorState);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Listing])

   
return (
    <ModalWithHeader
        buttonText={('Submit')}
        headerText={props.id ? ('Edit Listing') : ('Add Listing')}
        loading={loading}
        onClose={props.onClose}
        onSave={submitHandler}
        large
    >
        <div className={style.formWrapper}>
            <div className={style.intro}>
                <div className={style.introIcon}>
                    <User size={22} />
                </div>
                <div>
                    <h4 className={style.title}>{t('Listing Details')}</h4>
                    <p className={style.subtitle}>{t('Enter the contact details and information for this listing.')}</p>
                </div>
            </div>

            <form className={style.form} onSubmit={(e) => e.preventDefault()}>
                <div className={style.formGrid}>
                    {/* Image upload */}
                    <section className={style.imageSection}>
                        <div className={style.sectionHeading}>
                            <h5>{t('Listing Image')}</h5>
                            <span>{t('Preview')}</span>
                        </div>

                        <div className={style.imageCard}>
                            <div className={style.imagePreview}>
                                <img src={image || assets.images.listingImage} alt={t('Listing preview')} />
                            </div>

                            <div className={style.imageInfo}>
                                <h6>{t('Upload listing image')}</h6>
                                <p>{t('Choose an image or enter an image URL for your listing.')}</p>

                                <FormInput
                                    type={onCamera ? 'file' : 'text'}
                                    label={t('Image')}
                                    placeholder={t('Enter image URL')}
                                    errorText={imageError}
                                    value={onCamera ? undefined : image}
                                    onChange={imageChangeHandler}
                                    containerClass="mb-2"
                                    rightRenderer={onCamera ? <Edit /> : <Camera strokeWidth={2} />}
                                    onRightRendererClick={() => setOnCamera(!onCamera)}
                                />

                                {imageError && <p className={style.errorText}>{imageError}</p>}
                            </div>
                        </div>
                    </section>

                    {/* Listing details */}
                    <section className={style.detailsSection}>
                        <div className={style.sectionHeading}>
                            <h5>{t('Contact Information')}</h5>
                            <span>{t('Required fields')} *</span>
                        </div>

                        <div className={style.fieldGrid}>
                            <FormInput
                                type="text"
                                label={t('Title')}
                                placeholder={t('Enter listing title')}
                                errorText={titleError}
                                required
                                value={title}
                                onChange={TitleChangeHandler}
                                containerClass="mb-3"
                                rightRenderer={<User size={18} />}
                            />

                            <FormInput
                                type="text"
                                label={t('Name')}
                                placeholder={t('Enter full name')}
                                errorText={nameError}
                                required
                                value={name}
                                onChange={NameChangeHandler}
                                containerClass="mb-3"
                                rightRenderer={<User size={18} />}
                            />

                            <FormInput
                                type="text"
                                label={t('Phone Number')}
                                placeholder={t('Enter phone number')}
                                errorText={phoneNumberError}
                                required
                                value={phoneNumber}
                                onChange={PhonenumberChangeHandler}
                                containerClass="mb-3"
                                rightRenderer={<Phone size={18} />}
                            />

                            <FormInput
                                type="email"
                                label={t('Email')}
                                placeholder={t('Enter email address')}
                                errorText={emailError}
                                required
                                value={email}
                                onChange={EmailChangeHandler}
                                containerClass="mb-3"
                                rightRenderer={<Mail size={18} />}
                            />
                        </div>
                    </section>
                </div>

                {/* Message editor */}
                <section className={style.messageSection}>
                    <div className={style.sectionHeading}>
                        <h5>{t('Message')}</h5>
                        <span>{t('Required')}</span>
                    </div>

                    <div className={`${style.editorContainer} ${messageError ? style.editorError : ''}`}>
                        <Editor
                            editorState={message}
                            toolbarClassName={style.editorToolbar}
                            wrapperClassName={style.editorWrapper}
                            editorClassName={style.editorContent}
                            onEditorStateChange={MessageChangeHandler}
                            placeholder={t('Write your message here...')}
                        />
                    </div>

                    {messageError && <p className={style.errorText}>{messageError}</p>}
                </section>
            </form>
        </div>
    </ModalWithHeader>
)

}

export default ListingForm